/**
 * Les couleurs de l'état d'une intervention (comme au planning de Praxedo) : la même couleur partout où l'on voit où en est une
 * intervention — le bloc de la grille, la pastille du briefing, la légende au-dessus de la grille. La table des couleurs est dans
 * `domaine/planning-interventions.ts` ; ici, seulement l'affichage.
 */
import { LEGENDE_ETATS, couleurEtat } from '../domaine/planning-interventions';

/** La légende : une pastille de couleur par état, avec son nom. */
export function LegendeEtats() {
  return (
    <ul className="planning-legende" aria-label="Légende des couleurs">
      {LEGENDE_ETATS.map((e) => (
        <li key={e.classe}>
          <span className={`pastille-couleur etat-${e.classe}`} aria-hidden="true" />
          {e.libelle}
        </li>
      ))}
    </ul>
  );
}

/** La pastille de l'état d'une intervention, de la même couleur que son bloc dans la grille. */
export function PastilleEtat({ status }: { status: string }) {
  const e = couleurEtat(status);
  return <span className={`pastille-etat etat-${e.classe}`}>{e.libelle}</span>;
}
